once = (dom, event, callback) ->
  handler = (e) ->
    callback.call this, e
    @removeEventListener event, handler
    return
  dom.addEventListener event, handler
  return

module.exports = once